// src/components/CommentTable.js
import React from 'react';

const CommentTable = ({ entries, onDeleteEntry, isLoading, user, onError }) => {
  const handleDelete = async (entryId, authorId) => {
    // Only allow users to delete their own entries
    if (authorId !== user.uid) {
      onError("You can only delete your own entries.");
      return;
    }
    
    if (window.confirm('Are you sure you want to delete this comment?')) {
      try {
        await onDeleteEntry(entryId);
        // The UI will update automatically through the real-time listener
      } catch (error) {
        console.error("Error deleting entry:", error);
        onError("Failed to delete comment. Please try again.");
      }
    }
  };
  
  const formatDate = (timestamp) => {
    try {
      if (timestamp instanceof Date) {
        return timestamp.toLocaleString();
      } else if (timestamp?.toDate) {
        return timestamp.toDate().toLocaleString();
      } else if (typeof timestamp === 'string') {
        return new Date(timestamp).toLocaleString();
      }
      return 'Unknown date';
    } catch (e) {
      return 'Invalid date';
    }
  };
  
  if (isLoading) {
    return (
      <div className="table-container">
        <h3>Comments</h3>
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading comments...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="table-container">
      <h3>Comments</h3>
      {entries.length === 0 ? (
        <p className="no-entries">No comments yet. Be the first to add one!</p>
      ) : (
        <table className="entries-table">
          <thead>
            <tr>
              <th>Author</th>
              <th>Comment</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <tr key={entry.id} className="comment-row">
                <td className="author-cell">{entry.author}</td>
                <td className="content-cell">{entry.text}</td>
                <td className="date-cell">{formatDate(entry.createdAt || entry.timestamp)}</td>
                <td className="actions-cell">
                  {entry.authorId === user.uid && (
                    <button 
                      onClick={() => handleDelete(entry.id, entry.authorId)}
                      className="delete-button"
                      aria-label="Delete comment"
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CommentTable;